import { Injectable } from '@angular/core';
import { LinksBaseConhecimentoService } from 'src/app/content/pages/services/links-base-conhecimento.service';

import { IndexedDbService } from '../../content/pages/services/indexed-db.service';
import { isNullOrUndefined } from './../../../utils/util';
import { UserToken } from './user-token';

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  USUARIO_LOGADO = "usuariologado";
  AUTENTICADO = "autenticado";
  ACCESS_TOKEN = "accessToken";
  KEY_MODULO = "roteirizacao";

  constructor(
    private indexedDbModel: IndexedDbService,
    private linksBaseConhecimentoService: LinksBaseConhecimentoService
  ) {}

  obtenhaToken(): string {
    return sessionStorage.getItem(this.keyModulo(this.ACCESS_TOKEN));
  }

  estaAutenticado(): boolean {
    return sessionStorage.getItem(this.keyModulo(this.AUTENTICADO)) === "S";
  }

  obtenhaUsuarioLogado(): UserToken {
    return JSON.parse(
      sessionStorage.getItem(this.keyModulo(this.USUARIO_LOGADO))
    );
  }

  salvarUsuarioLogado(valor: any) {
    sessionStorage.setItem(
      this.keyModulo(this.USUARIO_LOGADO),
      JSON.stringify(valor)
    );
    this.linksBaseConhecimentoService.salvarSessionStorage();
  }

  salvarUsuarioAutenticado(valor: any): any {
    sessionStorage.setItem(this.keyModulo(this.AUTENTICADO), valor);
  }

  salvarToken(valor: any): any {
    sessionStorage.setItem(this.keyModulo(this.ACCESS_TOKEN), valor);
  }

  private keyModulo(value) {
    return `${this.KEY_MODULO}_${value}`;
  }

  public limparSessao() {
    sessionStorage.clear();
    this.indexedDbModel.limparLocalStorage();
  }

  usuarioTemPermissaoNaRota(rota: string): boolean {
    const userToken = this.obtenhaUsuarioLogado();
    if (userToken && !isNullOrUndefined(userToken.permissaoAcesso)) {
      return userToken.permissaoAcesso.indexOf(rota) >= 0;
    } else {
      // TODO invalidar navegacao
    }

    return false;
  }

  usuarioAdministrador() {
    const userToken = this.obtenhaUsuarioLogado();
    return userToken.isAdministrador;
  }
}
